import type { PageCard } from '@/play/pageTypes'
import { SpotlightCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'spotlight',
  number: 11,
  title: 'Spotlight',
  question: 'What happens when the child moves the light instead of the stuff?',
  status: 'open',
  accent: '#1b1f2c',
  CardArt: SpotlightCardArt,
}
